/**
 * TODO: Remove this helper once all legacy formats are phased out and the preference is standardized.
 * Normalizes galleryToolbarPlacement preference values to handle legacy formats.
 *
 * Maps legacy values to current standard:
 * - 'top-left'' → 'top'
 * - 'bottom-left' → 'bottom'
 * - 'top' → 'top'
 * - 'bottom' → 'bottom'
 *
 * @param {string} placement - The raw galleryToolbarPlacement preference value
 * @returns {string} - Normalized value: 'top' or 'bottom'
 */
export const normalizeToolbarPlacement = (placement) => {
	if (!placement) {
		return 'bottom';
	}

	// Handle specific legacy formats
	if (placement === 'top' || placement === 'top-left') {
		return 'top';
	}

	if (placement === 'bottom' || placement === 'bottom-left') {
		return 'bottom';
	}

	// Default fallback for unexpected values
	return 'bottom';
};
